import { render } from "./NoChatContainer.vue?vue&type=template&id=0a32c608&scoped=true"
const script = {}

import "./NoChatContainer.vue?vue&type=style&index=0&id=0a32c608&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a32c608"]])

export default __exports__